import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { FC, useState, useEffect } from "react";
import { JourneyProfileEditor } from "../journey/JourneyProfileEditor";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: "450px",
    maxWidth: "90%",
  },

  actions: {
    display: "flex",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    gap: theme.spacing(2),
  },
  actionButton: {
    flex: 1,
  },
}));

export interface ProfilePayload {
  id?: number;
  name: string;
  subtitle?: string;
  avatar: string;
  description?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (payload: ProfilePayload) => void;
  isPending?: boolean;
  initialData?: ProfilePayload | null;
}

export const JourneyProfileDialog: FC<Props> = ({
  open,
  onClose,
  onSave,
  isPending = false,
  initialData = null,
}) => {
  const s = useStyles();

  const [name, setName] = useState("");
  const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
  const [avatar, setAvatar] = useState("");

  const [description, setDescription] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!open) return;

    setName(initialData?.name || "");
    setSubtitle(initialData?.subtitle || "");
    setAvatar(initialData?.avatar || "");
    setDescription(initialData?.description || "");
  }, [initialData, open]);

  const handleSave = () => {
    if (!name.trim()) return;

    onSave({
      id: initialData?.id,
      name,
      subtitle,
      avatar,
      description,
    });

    handleClose();
  };

  const handleClose = () => {
    onClose();
  };

  const isEditMode = Boolean(initialData);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{ paper: s.dialogPaper }}
    >
      <DialogTitle>
        {isEditMode ? "Edit Profile" : "Create New Profile"}
      </DialogTitle>

      <DialogContent>
        <JourneyProfileEditor
          name={name}
          setName={setName}
          subtitle={subtitle}
          setSubtitle={setSubtitle}
          avatar={avatar}
          setAvatar={setAvatar}
          description={description}
          setDescription={setDescription}
        />
      </DialogContent>

      <DialogActions className={s.actions}>
        <Button
          className={s.actionButton}
          variant="outlined"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          className={s.actionButton}
          variant="contained"
          onClick={handleSave}
          disabled={isPending || !name.trim()}
        >
          {isEditMode ? "Save Changes" : "Save Profile"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
